export const reportTypes = [
  {
    title: 'Luminous',
    value: 'luminous',
  },
  {
    title: '3rd Party',
    value: '3rd_party',
  },
  {
    title: 'All',
    value: 'all',
  },
];

export const filterButtons = [
  {
    title: 'All Time',
    value: 'all_time',
  },
  {
    title: 'YTD',
    value: 'ytd',
  },
  {
    title: 'Today',
    value: 'today',
  },
  {
    title: 'This Week',
    value: 'this_week',
  },
  {
    title: 'This Month',
    value: 'this_month',
  },
];

export const paymentStatusLookUp = [
  {
    label: 'Unpaid',
    value: 0,
  },
  {
    label: 'Fully Paid',
    value: 1,
  },
  {
    label: 'Partially Paid',
    value: 2,
  },
  {
    label: 'Pending Payment',
    value: 3,
  },
];

export const poStatusLookUp = [
  {
    label: 'Active',
    value: 'ACTIVE',
  },
  {
    label: 'Completed',
    value: 'COMPLETED',
  },
];

export const poFrequencyLookUp = [
  {
    label: 'One-Time',
    value: 'one_time',
  },
  {
    label: 'Recurring',
    value: 'recurring',
  },
];

export const deliveryTypeLookUp = [
  {
    label: 'Standard',
    value: 'standard',
  },
  {
    label: 'Warehouse Pickup',
    value: 'warehouse',
  },
  {
    label: 'Local Delivery',
    value: 'local_delivery',
  },
];

export const includeUnPostedSalesEntriesLookUp = [
  {
    label: 'No',
    value: 0,
  },
  {
    label: 'Yes',
    value: 1,
  },
];

export const filterClientPurchaseOrderOnlyLookUp = [
  {
    label: 'No',
    value: 0,
  },
  {
    label: 'Yes',
    value: 1,
  },
];
